import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ChipModule } from '@commons/chip/chip.component';
import { TextTooltipModule } from '@commons/text-tooltip/text-tooltip.component';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';

@Component({
  selector: 'app-youth-info-center-tooltip',
  templateUrl: './youth-info-center-tooltip.component.html',
  styleUrls: ['./youth-info-center-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YouthInfoCenterTooltipComponent {
  @Input() url!: string;
  FeaturesRoutingEnum = FeaturesRoutingEnum;
}

@NgModule({
  imports: [TextTooltipModule, ChipModule, RouterModule],
  declarations: [YouthInfoCenterTooltipComponent],
  exports: [YouthInfoCenterTooltipComponent],
})
export class YouthInfoCenterTooltipModule {}
